var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWbgGrainsV2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    rx: 18,
    fill: "#FFEED6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.8984 27C9.64936 27 9.14783 24.8742 9.04374 24.0275C8.93168 23.2054 9.03573 22.3698 9.34655 21.5954C9.48316 21.2269 9.71814 20.8987 10.0284 20.6428C10.3386 20.387 10.7135 20.2124 11.1161 20.1362C12.2232 19.956 13.0086 20.5866 14.0117 20.8027C14.2001 20.8603 14.401 20.8704 14.5947 20.8321C14.7884 20.7937 14.9684 20.7082 15.1171 20.5839C15.2658 20.4596 15.3781 20.3007 15.4431 20.1228C15.5081 19.9449 15.5235 19.754 15.4879 19.5687C15.0715 18.0194 12.1097 17.9924 10.8984 17.9924C10.8984 16.3169 12.8288 16.1007 14.2104 16.2269C15.03 16.3022 15.837 16.4716 16.6139 16.7313C17.0871 16.8844 17.6359 17.2717 18.1563 17.2357C18.9417 17.1727 19.1026 16.398 18.762 15.8305C17.9387 14.4974 15.6014 14.3893 14.2104 14.3893C14.2104 12.5878 15.8474 12.2455 17.4183 12.5157C18.2293 12.6675 19.0198 12.9063 19.7745 13.2273C20.2571 13.4255 20.8343 13.8038 21.3642 13.6326C22.7268 13.2363 21.3074 11.8491 20.7018 11.5159C20.2768 11.2926 19.8258 11.1173 19.3581 10.9934C18.8471 10.8493 18.2226 10.9033 18.6863 10.3358C19.4113 9.72695 20.3108 9.33801 21.2696 9.2189C23.058 8.82256 25.5278 8.7505 25.9631 10.8943C26.1081 12.0262 25.8228 13.1701 25.1588 14.1191C23.3959 16.9895 21.2134 19.6068 18.6768 21.8927C17.3332 23.2037 15.8772 24.4059 14.3239 25.4867C13.3777 26.1353 12.1286 27 10.8984 27Z",
    fill: "#FF9300"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWbgGrainsV2);
export default __webpack_public_path__ + "static/media/wbg-grains-v2.3459cc6c9dec3ce712fdb5f81e84d228.svg";
export { ForwardRef as ReactComponent };